var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInstagram(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_667)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.78669 19V12.4308H7.99976V10.0656H9.78669V8.04535C9.78669 6.45785 10.8422 5 13.2745 5C14.2592 5 14.9874 5.09177 14.9874 5.09177L14.93 7.30049C14.93 7.30049 14.1874 7.29347 13.377 7.29347C12.4999 7.29347 12.3594 7.68638 12.3594 8.33851V10.0656H14.9998L14.8849 12.4308H12.3594V19H9.78669Z",
    fill: "#F6F6F6"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_667"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 7,
    height: 14,
    fill: "white",
    transform: "translate(7.99976 5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstagram);
export default __webpack_public_path__ + "static/media/instagram.85889dc28d97fa789a0f7c228bb235c1.svg";
export { ForwardRef as ReactComponent };